export class SchemaChangeEvent {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "occurredAt",
            "baseName": "occurredAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "SchemaChangeKind",
            "format": ""
        },
        {
            "name": "field",
            "baseName": "field",
            "type": "string",
            "format": ""
        },
        {
            "name": "fieldType",
            "baseName": "fieldType",
            "type": "string",
            "format": ""
        },
        {
            "name": "detail",
            "baseName": "detail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaChangeEvent.attributeTypeMap;
    }
    constructor() {
    }
}
